import { render, staticRenderFns } from "./InspurQid.vue?vue&type=template&id=18c1f5f4"
import script from "./InspurQid.vue?vue&type=script&lang=js"
export * from "./InspurQid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports